<template>
  <div class="page1">
    <EForm :formColumns="formColumns" :rowSize="5" :optionsBtn="true" :actionBtn="false" :formData="searchForm"
      ref="form" @onSearch="onSearch" :searchFlag="true" :exportShow="true" :exportData="searchForm" url="employexport" fileName="服务人员明细表"></EForm>
    <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="true" :count="count"
      @changePage="changePage" @changeSize="changeSize" :page="searchForm.current" :page_size="searchForm.size"
      @handleSelect="handleSelectionChange" :needSelect="false">
      <el-table-column fixed="right" label="操作" width="80px">
        <template slot-scope="scope">
          <div>
            <!--el-button type="text " @click="itemDetail(scope.row)">详情</el-button-->
            <el-button type="text" @click="editDialog(scope.row)">审核</el-button>
          </div>
        </template>
      </el-table-column>
      <div slot="checkStatus" slot-scope="scope">
        {{ scope.data.checkStatus == 3 ? '待审核' : scope.data.checkStatus == 1 ? '审核通过' : scope.data.checkStatus == 2 ?
          '审核未通过' :
        '-' }}
      </div>
    </ETable>
    <EDialog :dialogVisible="dialogVisible" :title="title" @handleClose="handleClose" width="60%"
      @handleClick="saveData">
      <ETable :tableTitle="tableTitle1" :tableData="tableData1" :needPagination="false" style="margin-left:20px;margin-right:20px">
      </ETable>
      <el-form label-position="right" label-width="150px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="cardNo">
              <el-input v-model="form.cardNo" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机" prop="mobile">
              <el-input v-model="form.mobile" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-input v-model="form.sex" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职位" prop="position">
              <el-input v-model="form.position" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="民族" prop="nation">
              <el-input v-model="form.nation" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户籍地" prop="registerDistrict">
              <el-input v-model="form.registerDistrict" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="户籍地详细地址" prop="registerDistrictAddress">
              <el-input v-model="form.registerDistrictAddress" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现住址" prop="liveDistrict">
              <el-input v-model="form.liveDistrict" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现住址详细地址" prop="liveDistrictAddress">
              <el-input v-model="form.liveDistrictAddress" readonly="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否为重点人员" prop="importantUser">
              <el-radio-group v-model="form.importantUser" disabled>
                <el-radio :label="0" readonly="true">否</el-radio>
                <el-radio :label="1" readonly="true">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="健康证" prop="healthCardImg">
              <img :src="form.healthCardImg" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审核状态" prop="checkStatus">
              <el-radio-group v-model="form.checkStatus">
                <el-radio :label="3">待审核</el-radio>
                <el-radio :label="1">审核通过</el-radio>
                <el-radio :label="2">审核未通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="原因" prop="remark">
              <el-input v-model="form.checkRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </EDialog>
    <EDialog :dialogVisible="dialogVisibleItem" :title="title" @handleClose="handleCloseItem" width="60%"
      @handleClick="handleCloseItem">
      <ETable :tableTitle="tableTitle1" :tableData="tableData1" :needPagination="false">
      </ETable>
    </EDialog>
  </div>
</template>

<script>
import ETable from '@/components/ETable'
import Http from "@/service/http";
import EDialog from '@/components/EDialog'
import EButton from '@/components/EButton'
import EForm from '@/components/EForm'
import vxRule from "@/assets/js/formValidate";
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      formColumns: [
        {
          title: '姓名',
          type: 'text',
          property: 'name',
          placeHolder: '请输入',
          show: true,
        },
        {
          title: '手机',
          type: 'text',
          property: 'mobile',
          placeHolder: '请输入',
          show: true
        },
        {
          title: '审核状态',
          type: 'select',
          property: 'checkStatus',//1审核通过，2审核未通过，3待审核
          show: true,
          options: [
            {
              label: '全部',
              value: '',
            },
            {
              label: '待审核',
              value: 3,
            },
            {
              label: '审核通过',
              value: 1,
            },
            {
              label: '审核未通过',
              value: 2,
            }
          ],
        },
        {
          title: '审核人',
          type: 'text',
          property: 'checkUser',
          placeHolder: '请输入',
          show: true
        }],
      tableTitle: [
        {
          label: '姓名',
          prop: 'name',
        },
        {
          label: '手机',
          prop: 'mobile',
        },
        {
          label: '性别',
          prop: 'sex',
        },
        {
          label: '登记时间',
          prop: 'createTime',
        },
        {
          label: '审核人',
          prop: 'checkUser'
        },
        {
          label: '审核状态',
          prop: 'checkStatus',
          type: 'slot'
        }
      ],
      tableData: [],
      loading: false,
      dialogVisible: false,
      title: '添加信息',
      form: {},
      searchForm: {
        name: '',
        mobile: '',
        boothCode: '',
        checkStatus: '',
        size: 10
      },
      cascader: false,
      options: [],
      count: null,
      formRules: {
        title: [vxRule(true, '', "blur", "标题不能为空")],
      },
      labelPosition: 'right',
      labelWidth: '100px',
      selectRoutes: [],
      dialogVisibleItem: false,
      tableTitle1: [
        {
          label: '摊位号',
          prop: 'boothCode',
        },
        {
          label: '位置',
          prop: 'placeName',
        },
        {
          label: '商户名称',
          prop: 'tenantName',
        }
      ],
      tableData1: [],
      count1: null
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {},
  created() {
    this.getData()
    //this.getOptions()
  },
  components: { ETable, EDialog, EButton, EForm },
  beforeMount() {

  },
  methods: {
    onSearch() {
      this.searchForm.current = 1
      this.getData()
    },
    changePage(page) {
      this.searchForm.current = page
      this.getData()
    },
    changeSize(size) {
      this.searchForm.size = size
      this.getData()
    },
    handleClose() {
      this.title = '审核信息'
      this.dialogVisible = false
      this.form = {}
      //this.$refs.form.resetFields()
    },
    handleCloseItem() {
      this.title = '摊位信息'
      this.dialogVisibleItem = false
    },
    handleSelectionChange(data) {
      if (data.length > 0) {
        data.forEach((item) => {
          this.selectRoutes.push(item.id);
        });
      }
    },
    deleteMore() {
      this.deleteInfo(this.selectRoutes.toString());
    },
    deleteInfo(ids) {
      this.$messageBox
        .confirm(`确定删除该信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then((res) => {
          this.removeRoute(ids);
        })
        .catch((res) => { });
    },
    async getData() {
      let res = await Http.employeelist(this.searchForm)
      if (res.code == 200) {
        this.tableData = res.data.records
        this.count = res.data.total
      }

    },
    saveData() {
      let flag = false
      this.$refs['form'].validate((valid, object) => {
        if (valid && !this.error) {
          flag = true
        } else {
          return false;
        }
      });
      if (flag) {
        this.addBtn()
      }
    },
    async addBtn() {
      let res = await Http.checkStatus(this.form)
      console.log(JSON.stringify(res))
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.handleClose()
        this.getData()
      }else{
        this.$message.error(res.msg)
        this.getData()
      }
    },
    async itemDetail(data){
      this.title = '摊位信息'
      this.tableData1 = []
      this.dialogVisibleItem = true
      let res = await Http.employeeitemlist({'employeeId':data.id})
      if (res.code == 200) {
        this.tableData1 = res.data
      }
    },
    async editDialog(data) {
      this.title = '审核信息'
      this.form = data
      //this.form = {
      //  name: data.name
      //}
      this.dialogVisible = true

      let res = await Http.employeeitemlist({'employeeId':data.id})
      if (res.code == 200) {
        this.tableData1 = res.data
      }
    },
    async removeRoute(ids) {
      let res = await Http.noticeRemoveRoute({ ids });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;

}
</style>
